import { mockUtils } from "../../../development/mocks/mock-utils";
import { numberFromString } from "../../events-screen/parent-events-mocks/mock-utils-functions";
import { AppUserModel } from "../user-management-models/app-user.model";
import { UserEditPermissionLevel } from "../user-management-models/user-privilege-edit-type.enum";

/**
 * the discount price is not the one that is shown in the UI, but the one that  came from the server
 * if the discount price is more than 0 then there is an active discount
 */
export const applicationUsersMock: AppUserModel[] = [
  ...mockUtils.usersWithUserNamesAndEmails,
  ...mockUtils.usersWithUserNamesAndEmails,
  ...mockUtils.usersWithUserNamesAndEmails,
].map((user, index) => {
  const mobileNumber = `05${mockUtils.createIntRandomIntInRange(
    0,
    5
  )}-${mockUtils.createIntRandomIntInRange(1234567, 9876543).toString()}`;
  const randomDaysBefore = mockUtils.createIntRandomIntInRange(0, 20);
  const activityCircles = mockUtils.citiesAndNests
    .filter((city, i) => {
      return i < 5;
    })
    .join(", ");
  const isEditable =
    numberFromString(`${mockUtils.hebFirstNames[index]}${index * 10}`, 100) >
    50;
  const appUser: AppUserModel = {
    canEditPermissionLevel: isEditable
      ? UserEditPermissionLevel.EditDetails
      : UserEditPermissionLevel.EditPermissions,
    activityCircles,
    isActive: Math.random() > 0.3,
    lastLogin: new Date(
      new Date().getTime() - 1000 * 60 * 60 * 24 * randomDaysBefore
    ),
    mobileNumber,
    id: index.toString(),
    firstName: mockUtils.hebFirstNames[index],
    lastName: mockUtils.hebLastNames[index],
    email: user.email,
    userName: user.userName,
  };

  return appUser;
});



// WEBPACK FOOTER //
// ./src/app/admin/users/mocks/app-users-mock.ts